import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import LostPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'lostPasswordPanel';
const FORM_ID = 'lostPasswordForm';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createLostPasswordScreen = () => {
  const domId = 'lostPasswordPanel';
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <LostPasswordPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createLostPasswordScreen = createLostPasswordScreen;
export { namespace, FORM_ID };
